export default {
  Register: {
    RegisterTeacherAccount: 'Đăng ký tài khoản giáo viên',
    RegisterStudentAccount: 'Đăng ký tài khoản học sinh',
    RegisterSuccess: 'Đăng ký thành công!',
    MessageRegisterSuccessPrefix: 'Chúc mừng bạn đã đăng ký tài khoản thành công. Từ giờ bạn có thể sử dụng',
    MessageRegisterSuccessSurfix: 'để đăng nhập',
    NotHaveYourSchool: 'Trường của bạn không có trong Danh sách?',
    RegisterExperienceHere: 'Đăng ký trải nghiệm tại đây',
    WelcomeJoinClass: 'Chào mừng bạn đã tham gia lớp '
  }
}
